// Single, shared, page-wide "live" clock that ticks once per second.
// Every CvSnapshot subscribes via useNowSecond() instead of running its own setInterval.
// This avoids dozens of timers + dozens of independent re-renders per second
// when the page has many feature cards.
let listeners = new Set();
let timer = null;
let lastValue = formatNow();

function formatNow(d = new Date()) {
  const pad = (n) => String(n).padStart(2, "0");
  return `${d.getFullYear()}-${pad(d.getMonth() + 1)}-${pad(d.getDate())} ${pad(d.getHours())}:${pad(d.getMinutes())}:${pad(d.getSeconds())}`;
}

function start() {
  if (timer) return;
  timer = setInterval(() => {
    const next = formatNow();
    if (next === lastValue) return;
    lastValue = next;
    listeners.forEach((cb) => {
      try { cb(next); } catch { /* ignore */ }
    });
  }, 1000);
}

function stop() {
  if (timer && listeners.size === 0) {
    clearInterval(timer);
    timer = null;
  }
}

import { useEffect, useState } from "react";

export function useNowSecond() {
  const [now, setNow] = useState(lastValue);
  useEffect(() => {
    listeners.add(setNow);
    start();
    return () => {
      listeners.delete(setNow);
      stop();
    };
  }, []);
  return now;
}
